export const Texts = {
  open_modal: "Open Modal",
  close_button: "Kapat",
  submit_button: "Gönder",
  title_1: "Bir Problemle mi Karşılaştın? 🤔",
  title_2: "Yorum Yapabilirsin",
  placeHolder_comment: "yorumlarını bu alana girebilirsin...",
  get_error: "API'den veri alınırken hata oluştu",
  post_error: "API'ye veri gönderilirken hata oluştu",
  post_success: "Yorum gönderildi!",
  warning_select: "Lütfen seçim yapınız",
  loading: "Loading ...",
};
